/**
 * Tiny window-event bus so any dashboard chrome (e.g. the mobile header
 * "תמיכה" button) can open the Lenny chat without prop-drilling into the
 * portaled SupportChatWidget.
 */
export const LENNY_OPEN_EVENT = "clinikit:lenny:open";

/** Opens the Lenny chat if the widget is mounted (no-op otherwise). */
export function openLenny() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(LENNY_OPEN_EVENT));
}
